import client from "./client.js";

export async function listSchedules() {
  const res = await client.get("/on-call/schedules");
  return res.data.data;
}

export async function createSchedule(data) {
  const res = await client.post("/on-call/schedules", data);
  return res.data.data;
}

export async function getSchedule(id) {
  const res = await client.get(`/on-call/schedules/${id}`);
  return res.data.data;
}

export async function updateSchedule(id, data) {
  const res = await client.put(`/on-call/schedules/${id}`, data);
  return res.data.data;
}

export async function deleteSchedule(id) {
  await client.delete(`/on-call/schedules/${id}`);
}

export async function createRotation(scheduleId, data) {
  const res = await client.post(`/on-call/schedules/${scheduleId}/rotations`, data);
  return res.data.data;
}

export async function updateRotation(scheduleId, rotationId, data) {
  const res = await client.put(
    `/on-call/schedules/${scheduleId}/rotations/${rotationId}`,
    data
  );
  return res.data.data;
}

export async function deleteRotation(scheduleId, rotationId) {
  await client.delete(`/on-call/schedules/${scheduleId}/rotations/${rotationId}`);
}

export async function getScheduleShifts(id, from, to) {
  const res = await client.get(`/on-call/schedules/${id}/shifts`, {
    params: { from, to },
  });
  return res.data.data;
}

export async function createOverride(scheduleId, data) {
  const res = await client.post(`/on-call/schedules/${scheduleId}/overrides`, data);
  return res.data.data;
}

export async function deleteOverride(scheduleId, overrideId) {
  await client.delete(`/on-call/schedules/${scheduleId}/overrides/${overrideId}`);
}

export async function takeover(scheduleId) {
  const res = await client.post(`/on-call/schedules/${scheduleId}/takeover`);
  return res.data.data;
}

export async function getCurrentOnCall() {
  const res = await client.get("/on-call/current");
  return res.data.data;
}

export async function listEscalationPolicies() {
  const res = await client.get("/on-call/escalation-policies");
  return res.data.data;
}

export async function createEscalationPolicy(data) {
  const res = await client.post("/on-call/escalation-policies", data);
  return res.data.data;
}

export async function getEscalationPolicy(id) {
  const res = await client.get(`/on-call/escalation-policies/${id}`);
  return res.data.data;
}

export async function updateEscalationPolicy(id, data) {
  const res = await client.put(`/on-call/escalation-policies/${id}`, data);
  return res.data.data;
}

export async function deleteEscalationPolicy(id) {
  await client.delete(`/on-call/escalation-policies/${id}`);
}
